import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { TokenService } from 'src/app/core/services/token.service';

@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit {
  @Input('appHasPermission') requiredPermissions: string[] = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private tokenService: TokenService
  ) {}

  ngOnInit() {
      const userPermissions = this.tokenService.getUserPermissionsFromToken();

    // Check if user has ALL the required permissions
    const hasPermission = this.requiredPermissions.some(p => userPermissions.includes(p));

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
